<div class="searchable-select" [class.is-open]="isOpen" [class.is-disabled]="disabled">
  <ng-container *ngIf="!isOpen; else openTrigger">
    <div class="searchable-select-trigger searchable-select-trigger-closed">
      <button
        type="button"
        class="searchable-select-trigger-action"
        [attr.id]="id || null"
        [attr.aria-expanded]="isOpen"
        [disabled]="disabled"
        (click)="toggleDropdown()"
      >
        <span class="searchable-select-trigger-label">{{ displayLabel }}</span>
      </button>
      <button
        *ngIf="hasValue"
        type="button"
        class="searchable-select-clear-btn"
        [disabled]="disabled"
        aria-label="Clear selection"
        (click)="onClearValue($event)"
      >
        <i class="fa fa-times-circle"></i>
      </button>
      <button
        type="button"
        class="searchable-select-chevron-btn"
        [disabled]="disabled"
        [attr.aria-expanded]="isOpen"
        (click)="toggleDropdown()"
      >
        <i class="fa" [ngClass]="isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </button>
    </div>
  </ng-container>

  <ng-template #openTrigger>
    <div class="searchable-select-trigger searchable-select-trigger-open">
      <input
        #searchInput
        [attr.id]="id || null"
        type="text"
        class="searchable-select-trigger-input"
        [value]="searchTerm"
        [placeholder]="searchPlaceholder"
        [disabled]="disabled"
        (input)="onSearchInput($event)"
        (keydown.enter)="onSearchEnter($event)"
      />
      <button
        type="button"
        class="searchable-select-clear-btn"
        [disabled]="disabled || !hasSearchTerm"
        aria-label="Clear search"
        (click)="onClearSearch($event)"
      >
        <i class="fa fa-times-circle"></i>
      </button>
      <button
        type="button"
        class="searchable-select-chevron-btn"
        [disabled]="disabled"
        (click)="toggleDropdown()"
      >
        <i class="fa fa-chevron-up"></i>
      </button>
    </div>
  </ng-template>

  <div class="searchable-select-menu" *ngIf="isOpen">
    <div class="searchable-select-options" [style.max-height]="normalizedDropdownMaxHeight">
      <button
        type="button"
        class="searchable-select-option searchable-select-option-custom"
        *ngIf="hasCustomOption"
        (click)="onSelectCustomValue()"
      >
        <span>Use "{{ trimmedSearchTerm }}"</span>
        <i class="fa fa-plus"></i>
      </button>

      <button
        type="button"
        class="searchable-select-option"
        *ngFor="let item of filteredOptions; trackBy: trackByOptionId"
        [class.is-selected]="isSelected(item)"
        (click)="onSelect(item)"
      >
        <span>{{ item.name }}</span>
        <i *ngIf="isSelected(item)" class="fa fa-check"></i>
      </button>

      <div class="searchable-select-empty" *ngIf="filteredOptions.length === 0 && !hasCustomOption">No results</div>
    </div>
  </div>
</div>
